import { Link } from 'react-router-dom';

const features = [
  {
    icon: 'ri-smartphone-line',
    title: '下拉式阅读',
    description: '专为手机优化的下拉式漫画阅读体验，流畅滑动，沉浸式观感。',
  },
  {
    icon: 'ri-hd-line',
    title: '高清画质',
    description: '所有漫画均提供高清画质，细节清晰可见，给你最佳的视觉享受。',
  },
  {
    icon: 'ri-user-star-line',
    title: '无需注册',
    description: '无需注册账号，打开即看，畅享全部漫画内容，零门槛体验。',
  },
  {
    icon: 'ri-treasure-map-line',
    title: '海量资源',
    description: '收录数千部韩国热门漫画，涵盖恋爱、奇幻、动作等多种类型。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日更新',
    description: '热门漫画每日同步更新，第一时间追更，不错过任何精彩内容。',
  },
  {
    icon: 'ri-heart-add-line',
    title: '收藏功能',
    description: '支持收藏喜欢的漫画，方便随时回顾，打造你的专属书架。',
  },
];

export default function FeaturesSection() {
  return (
    <section className="py-10 md:py-14">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground-100 mb-2">
            为什么选择韩漫网
          </h3>
          <p className="text-sm text-foreground-400 max-w-lg mx-auto">
            致力于为中文读者提供最优质的韩国漫画阅读体验
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="flex flex-col items-center text-center p-4 rounded-lg bg-background-800/30 border border-background-700/20 hover:border-primary-500/20 transition-all duration-300"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-primary-500/10 mb-3">
                <i className={`${feature.icon} text-xl text-primary-500`}></i>
              </div>
              <h4 className="text-sm font-medium text-foreground-200 mb-1.5">{feature.title}</h4>
              <p className="text-xs text-foreground-500 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}